// import { APP_ROUTES } from '@/routes';

// export const DRAWER_MENU_CONFIG = [
// 	{
// 		heading: 'ourCollection.heading',
// 		links:   [
// 			{
// 				label: 'ourCollection.links.crisis',
// 				href:  APP_ROUTES.SHOP.COLLECTION.replace(':collectionSlug', 'crisis'),
// 			},
// 			{
// 				label: 'ourCollection.links.natureClub',
// 				href:  APP_ROUTES.SHOP.COLLECTION.replace(':collectionSlug', 'nature-club'),
// 			},
// 			{
// 				label: 'ourCollection.links.onBoard',
// 				href:  APP_ROUTES.SHOP.COLLECTION.replace(':collectionSlug', 'on-board'),
// 			},
// 		],
// 	},
// 	{
// 		heading: 'specialPrice.heading',
// 		href:    APP_ROUTES.SHOP.SPECIAL_PRICE,
// 	},
// 	{
// 		heading: 'SustainableMove.heading',
// 		href:    APP_ROUTES.ABOUT.SUSTAINABLE_MOVE,
// 	},
// 	{
// 		heading: 'aboutWT.heading',
// 		links:   [
// 			{
// 				label: 'aboutWT.links.aboutUs',
// 				href:  APP_ROUTES.ABOUT.ABOUT_WT,
// 			},
// 			{
// 				label: 'aboutWT.links.wasticFolks',
// 				href:  APP_ROUTES.ABOUT.WT_FOLK,
// 			},
// 			{
// 				label: 'aboutWT.links.contactUs',
// 				href:  APP_ROUTES.CUSTOMER_CARE.CONTACT_US,
// 			},
// 		],
// 	},
// 	{
// 		heading: 'findStores.heading',
// 		href:    APP_ROUTES.ABOUT.STORES_LIST,
// 	},
// 	{
// 		heading: 'faq.heading',
// 		href:    APP_ROUTES.CUSTOMER_CARE.FAQ,
// 	},
// ];
